import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("areas-perfil-select", {
                attrs: {
                  areas: _vm.perfil.areasCultura,
                  lista: _vm.listaAreasCultura,
                  instrutor: _vm.perfil.instrutorCultura,
                  "maximo-areas": 5,
                  "maximo-cursos": 5,
                  tipo: "CULTURA",
                  icone: "palette",
                  "permite-criar-area": "",
                },
                on: {
                  return: (value) => _vm.saveAreasCultura(value),
                  confirm: (value) => _vm.saveInstrutorCultura(value),
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("areas-perfil-select", {
                attrs: {
                  areas: _vm.perfil.areasEsporte,
                  lista: _vm.listaAreasEsporte,
                  instrutor: _vm.perfil.instrutorEsporte,
                  "maximo-areas": 5,
                  "maximo-cursos": 5,
                  tipo: "ESPORTE",
                  icone: "directions_bike",
                  "permite-criar-area": "",
                },
                on: {
                  return: (value) => _vm.saveAreasEsporte(value),
                  confirm: (value) => _vm.saveInstrutorEsporte(value),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }